export default "__VITE_ASSET__4tfX_ZuI__"